import { useEffect, useState } from "react";
import { LOYALTY_API_BASE } from "../constants";
import { loyaltyFetch } from "./loyaltyFetch";

/** GET /admin/loyalty-tiers/ui-catalog */
export function useLoyaltyTiersUiCatalog(brandName) {
    const [catalog, setCatalog] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!brandName) {
            setCatalog(null);
            return undefined;
        }
        let cancelled = false;
        setLoading(true);
        loyaltyFetch(`${LOYALTY_API_BASE}/admin/loyalty-tiers/ui-catalog`, {
            headers: { "X-Brand": brandName },
        })
            .then(async (res) => {
                const data = res.ok ? await res.json().catch(() => null) : null;
                if (!cancelled) setCatalog(data);
            })
            .catch(() => { if (!cancelled) setCatalog(null); })
            .finally(() => { if (!cancelled) setLoading(false); });
        return () => { cancelled = true; };
    }, [brandName]);

    return { catalog, loading };
}
